module.exports = __webpack_public_path__ + "img/check-success.7ea49bb2.svg";